import classNames from 'classnames';
import { Button } from 'primereact/button';
import { Menu } from 'primereact/menu';
import { createRef } from 'react';
import { FaFacebookF, FaInstagram, FaLinkedinIn } from 'react-icons/fa';
import { TbSunMoon } from 'react-icons/tb';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { ImagemLogo } from '../components/imagensDinamicas';
import { useTheme } from '../context/themeContext';
import { MenuPague } from '../styles/primeReactConfig';

function App() {
  const navigate = useNavigate()
  const menuRef = createRef()
  //const [rerender, setRerender] = useState(false)
  const { itemsTheme } = useTheme()

  function toggleMenu(e) {
    if (!menuRef.current) {
    } else menuRef.current.toggle(e);
  }


  return (
    <div className="grid overflow-auto bg-[#f1f2f3] dark:bg-pague_azul">
      <div className="w-full z-2 grid grid-cols-1 lg:grid-cols-3 sticky 
      h-20 items-center">
        <div className="items-center justify-center lg:justify-start h-20 flex">
          <a href="https://direto.tech" >
            <ImagemLogo />
          </a>
          <Button
            pt={{
              root: classNames(
                "rounded-full bg-black text-white ",
                "dark:text-black dark:bg-white",
                "flex items-center justify-center w-6 h-6",
              ),
              label: "absolute"
            }}
            onClick={toggleMenu}
            icon={<TbSunMoon />}
          />
          <Menu
            popup
            ref={menuRef}
            model={itemsTheme}
            pt={MenuPague}
          />
        </div>
        <div className="lg:flex justify-evenly h-20 hidden text-2xl items-center font-bold">
          <a href="https://direto.tech/" target="_blank" rel="noopener noreferrer">
            <ul>
              <h4>Quem somos</h4>
            </ul>
          </a>
          <a href="https://www.direto.tech/solucoes" target="_blank" rel="noopener noreferrer">
            <ul>
              <h4>Nossas Soluções</h4>
            </ul>
          </a>
          <a href="https://www.direto.tech/sobre" target="_blank" rel="noopener noreferrer">
            <ul>
              <h4>Sobre</h4>
            </ul>
          </a>
        </div>
        <div className="lg:flex justify-end hidden">
          <div className="p-4 mt-2">
            <a href="https://br.linkedin.com/company/diretotech?trk=affiliated-pages"
              className="rounded-full justify-center 
              items-center flex outline outline-2 h-8 w-8 text-xl"
              target="_blank"
              rel="noopener noreferrer" >
              <FaLinkedinIn />
            </a>
          </div>
          <div className="p-4 mt-2">
            <a href="https://www.instagram.com/diretotech/"
              className="rounded-full justify-center 
              items-center flex outline outline-2 h-8 w-8 text-xl"
              target="_blank"
              rel="noopener noreferrer" >
              <FaInstagram />
            </a>
          </div>
          <div className="p-4 mt-2">
            <a href="https://www.facebook.com/direto.tecnologia"
              className="rounded-full justify-center 
              items-center flex outline outline-2 h-8 w-8 text-xl"
              target="_blank"
              rel="noopener noreferrer" >
              <FaFacebookF />
            </a>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 h-[calc(100vh-5rem)]" >
        <div className="grid px-6 items-center">
          <div className='text-left grid gap-2'>
            <h1 className='text-4xl font-bold'>
              O JEITO MAIS FÁCIL,
              RÁPIDO E SEGURO
              DE FAZER A GESTÃO
              DO SEU NEGÓCIO.
            </h1>
            <h4 className='text-xl'>1. Gestão de Recebiveis</h4>
            <h4 className='text-xl'>2. Gestão da inadimplência </h4>
            <h4 className='text-xl'>3. Facilidade de pagamento </h4>
            <h4 className='text-xl'>
              Em caso de <b>inadimplência</b> sua empresa já
              possui uma <b>solução completa</b>
            </h4>
            <h3 className='text-2xl font-bold'>COMECE A RECUPERAR AGORA</h3>
            <div className='grid py-4'>
              <button className='bg-pague_azul dark:bg-pague_verde
              text-white
              hover:bg-sky-900 hover:dark:bg-pague_verde_claro
              transition-colors duration-300
              py-3 px-8 rounded-xl text-2xl font-bold'
                onClick={() => navigate('/cadastro/passo0')}
              >
                CRIE SUA CONTA
              </button>
            </div>
            <h3 className='text-2xl'>Caso já seja nosso
              cliente <a href='/login' className='underline font-bold'>Clique aqui</a>
            </h3>
          </div>
        </div>
        <div className='col-span-2 items-end lg:grid hidden'>
          <img src='/cover-home.png' alt="front_cover" />
        </div>
      </div>
    </div>
  );
}

export default App;